import React from "react";
import { ErrorMessage } from "@hookform/error-message";

const Input = ({
  label,
  name,
  register,
  type,
  errors,
  onBlur = () => {},
  onChange = () => {},
  disabled,
  value,
  dirtyFields,
  className,
  labelClassName = "p-title",
  toggleVisibility,
  showPassword,
  isPasswordField = false, // האם השדה הוא שדה סיסמה
}) => {
  // Prevent non-digit characters from being entered in tel fields
  const handleKeyPress = (e) => {
    if (type === "tel" && !/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <span>
      <label className={labelClassName} htmlFor={name}>
        {label}
      </label>
      <div className="input-wrapper" style={{ position: "relative" }}>
        <input
          className={`${className} ${dirtyFields && dirtyFields[name] ? "dirtyFields" : ""}`}
          type={type}
          {...register(name, {
            onBlur: (e) => {
              onBlur(e);
            },
            onChange: (e) => {
              onChange(e);
            },
          })}
          id={name}
          disabled={disabled}
          value={value}
          onKeyPress={handleKeyPress}
          style={isPasswordField ? { paddingRight: "40px" } : {}}
        />
        {isPasswordField && (
          <span
            onClick={toggleVisibility}
            className="password-icon"
            style={{
              position: "absolute",
              right: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
            }}
          >
            {showPassword ? (
              <i className="fa fa-eye-slash"></i>
            ) : (
              <i className="fa fa-eye"></i>
            )}
          </span>
        )}
      </div>
      {errors ? (
        <div style={{ color: "red" }}>
          {errors[name] ? errors[name].message : null}
        </div>
      ) : null}
    </span>
  );
};

export default Input;

export const Select = React.forwardRef(
  ({ name, label, options, errors, onChange, className }, ref) => (
    <div className={className}>
      <label htmlFor={name}>{label}</label>
      <select
        id={name}
        name={name}
        ref={ref}
        onChange={onChange ? onChange : null}
      >
        <option value="" disabled defaultValue="">
          בחר
        </option>
        {options
          ? options.map((x) => (
              <option
                key={x.slug || x.Id || x.id}
                value={x.slug || x.Id || x.id}
              >
                {x.Name || x.name}
              </option>
            ))
          : null}
      </select>
      <ErrorMessage errors={errors} name={name} />
    </div>
  ),
);
